import { Modal, Row, Col, Form } from 'react-bootstrap';
import { useEffect, useState, useRef } from "react";
import { Button } from "react-bootstrap";
import Spinner from 'react-bootstrap/Spinner';
import { FormInputElement } from '../../Form/FormInputElement';
import Select from '../../../components/Form/Select';
import { useApiClient } from '../../../ApiService/useApiClient';

const AddEditClientMedications = ({ show, action, setShowAddEdit, data, setdata, CustomerId, fulldata }) => {

  const api = useApiClient();

  const formDefault = {
    opened: true,
    modalTitle: (action !== "add" ? "Medication Details" : "Add New Medication"),
    status: "Active",
  };

  const [formModal, setFormModal] = useState(formDefault);
  const [error, setError] = useState(null);
  const [formErrors, setFormErrors] = useState({});
  const modalForm = useRef(null);
  const [selectedSchedule, setselectedSchedule] = useState([]);
  const [status, setStatus] = useState("Active");

  useEffect(() => {
    if (action !== "add" && data) {
      const scheduleArray = data.emarDailySchedule?.split(',').map(s => s.trim()) || [];

      setFormModal({
        ...formModal,
        opened: show,
        action: action,
        emarMedicationName: data.emarMedicationName,
        emarMedicationDesc: data.emarMedicationDesc,
        emarMedicationDosage: data.emarMedicationDosage,
        emarDailySchedule: scheduleArray,
        emarMedicationUsageInstructions: data.emarMedicationUsageInstructions,
        emar_medication_start_date: data.emar_medication_start_date,
        emar_medication_end_date: data.emar_medication_end_date,
        status: data.status || "Active",
        Id: data.id,
      });

      setselectedSchedule(scheduleArray);
      setStatus(data.status || "Active");
    } else {
      setFormModal({ ...formModal, opened: show, action: action });
      setselectedSchedule([]);
      setStatus("Active");
    }
  }, [show]);

  const closeFormModal = () => {
    setFormModal({ ...formModal, opened: false });
    setShowAddEdit(false);
    setFormErrors({});
  };

  const validateForm = (values) => {
    const errors = {};

    if (!values.emarMedicationName?.trim()) {
      errors.emarMedicationName = "Medication name is required.";
    }

    if (!values.emarMedicationDosage?.trim()) {
      errors.emarMedicationDosage = "Dosage is required.";
    }

    if (!values.selectedSchedule || values.selectedSchedule.length === 0) {
      errors.emarDailySchedule = "At least one schedule must be selected.";
    }

    if (values.emar_medication_end_date && values.emar_medication_start_date) {
      const start = new Date(values.emar_medication_start_date);
      const end = new Date(values.emar_medication_end_date);
      if (start >= end) {
        errors.emar_medication_end_date = "End date must be after start date.";
      }
    }

    return errors;
  };

  const handleFormSubmit = (event) => {
    event.preventDefault();

    const form = modalForm.current;
    const values = {
      emarMedicationName: form.querySelector('#emarMedicationName').value,
      emarMedicationDosage: form.querySelector('#emarMedicationDosage').value,
      emarMedicationUsageInstructions: form.querySelector('#emarMedicationUsageInstructions').value,
      emarMedicationDesc: form.querySelector('#emarMedicationDesc').value,
      selectedSchedule: selectedSchedule,
      emar_medication_start_date: form.querySelector('#emar_medication_start_date')?.value,
      emar_medication_end_date: status !== "Active" ? form.querySelector('#emar_medication_end_date')?.value : null,
      status: status,
    };

    const errors = validateForm(values);
    setFormErrors(errors);

    if (Object.keys(errors).length > 0) return;

    const frmFormData = new FormData();
    if (formModal.action !== "add") frmFormData.append("Id", formModal.Id);

    frmFormData.append("CustomerId", CustomerId);
    frmFormData.append("EmarMedicationName", values.emarMedicationName);
    frmFormData.append("EmarMedicationDesc", values.emarMedicationDesc);
    frmFormData.append("EmarMedicationDosage", values.emarMedicationDosage);
    frmFormData.append("EmarDailySchedule", selectedSchedule.join(','));
    frmFormData.append("EmarMedicationUsageInstructions", values.emarMedicationUsageInstructions);
    frmFormData.append("status", status);
    frmFormData.append("emar_medication_start_date", values.emar_medication_start_date);
    if (status !== "Active") frmFormData.append("emar_medication_end_date", values.emar_medication_end_date);

    const sURLSuffix = formModal.action !== "add"
      ? "HMCareData/customer/modifymedication/"
      : "HMCareData/customer/addmedication/";

    const sURL = sURLSuffix;
   
    api.post(sURL, frmFormData)
      .then((Response) => {
        const updatedDataObj = Response.data;
        if (formModal.action !== "add") {
          const updatedData = fulldata.map(el => (el.id === updatedDataObj.id ? {
            ...el,
            emarMedicationName: updatedDataObj.emarMedicationName,
            emarMedicationDesc: updatedDataObj.emarMedicationDesc,
            emarMedicationDosage: updatedDataObj.emarMedicationDosage,
            emarMedicationUsageInstructions: updatedDataObj.emarMedicationUsageInstructions,
            emarDailySchedule: updatedDataObj.emarDailySchedule,
            status: updatedDataObj.status,
            emar_medication_start_date: updatedDataObj.emar_medication_start_date,
            emar_medication_end_date: updatedDataObj.emar_medication_end_date,
          } : el));
          setdata(updatedData);
        } else {
          setdata([...data, updatedDataObj]);
        }
      })
      .catch(error => {
        setError(error);
        console.error(error);
      });

    closeFormModal();
  };

  const handleScheduleSelectChange = (e) => {
    const value = Array.from(e.target.options).filter(o => o.selected).map(o => o.value);
    setselectedSchedule(value);
  };

  return (
    <Modal show={formModal.opened} onHide={closeFormModal} size="lg" backdrop="static">
      <Form ref={modalForm} onSubmit={handleFormSubmit}>
        <Modal.Header closeButton>
          <Modal.Title className="event-title" as="h4">{formModal.modalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {false && <Spinner animation="border" variant="primary" />}
          <Row className="g-gs">
            <FormInputElement
              type="text"
              id="emarMedicationName"
              ColWidth={10}
              maxLength={255}
              Label="Medication"
              defaultValue={formModal.emarMedicationName}
              placeholder="Name"
              isInvalid={!!formErrors.emarMedicationName}
              feedback={formErrors.emarMedicationName}
            />
            
            <FormInputElement
              type="textarea"
              id="emarMedicationDesc"
              ColWidth={10}
              maxLength={150}
              Label="Description (Optional)"
              defaultValue={formModal.emarMedicationDesc}
              placeholder="Description"
            />
            <FormInputElement
              type="text"
              id="emarMedicationDosage"
              ColWidth={10}
              maxLength={255}
              Label="Dose"
              defaultValue={formModal.emarMedicationDosage}
              placeholder="Dose"
              isInvalid={!!formErrors.emarMedicationDosage}
              feedback={formErrors.emarMedicationDosage}
            />
            
            <Col xs="10">
              <Form.Group>
                <Form.Label>Medication Schedule</Form.Label>
                <div className={`form-control-wrap ${formErrors.emarDailySchedule ? 'is-invalid' : ''}`}>
                  <Select
                    id="emarDailySchedule"
                    onChange={handleScheduleSelectChange}
                    multiple
                    value={selectedSchedule}
                    removeItemButton
                    searchEnabled
                  >
                    <option value="Morning">Morning</option>
                    <option value="Lunch">Lunch</option>
                    <option value="Evening">Evening</option>
                    <option value="Night">Night</option>
                    <option value="As Needed">As Needed</option>
                  </Select>
                  {formErrors.emarDailySchedule && (
                    <div className="invalid-feedback d-block">{formErrors.emarDailySchedule}</div>
                  )}
                </div>
              </Form.Group>
            </Col>

            <FormInputElement
              type="textarea"
              id="emarMedicationUsageInstructions"
              ColWidth={10}
              maxLength={150}
              Label="Usage Instructions"
              defaultValue={formModal.emarMedicationUsageInstructions}
              placeholder="Usage instructions (if any)"
            />

            <Col xs="6">
              <Form.Group>
                <Form.Label>Medication Status</Form.Label>
                <Form.Select id="status" value={status} onChange={e => setStatus(e.target.value)}>
                  <option value="Active">Active</option>
                  <option value="Stopped">Stopped</option>
                  <option value="Discontinued">Discontinued</option>
                </Form.Select>
              </Form.Group>
            </Col>

            <FormInputElement
              type="date"
              id="emar_medication_start_date"
              ColWidth={6}
              Label="Start Date"
              defaultValue={formModal.emar_medication_start_date || ''}
            />
            {status !== "Active" && (
              <>
                <FormInputElement
                  type="date"
                  id="emar_medication_end_date"
                  ColWidth={6}
                  Label="End Date"
                  defaultValue={formModal.emar_medication_end_date || ''}
                  isInvalid={!!formErrors.emar_medication_end_date}
                  feedback={formErrors.emar_medication_end_date}
                />
                {formErrors.emar_medication_end_date && (
                  <div className="invalid-feedback d-block">
                    {formErrors.emar_medication_end_date}
                  </div>
                )}
              </>
            )}
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={closeFormModal}>Discard</Button>
          <Button variant="primary" type="submit">
            {formModal.action === 'add' ? 'Add Medication' : 'Update Medication'}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default AddEditClientMedications;
